import * as React from 'react';
import $ from "jquery";
import Common from '../utilities/common';
import { Alert, Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, FormControl, InputLabel, MenuItem, Select, SelectChangeEvent, TextField } from '@mui/material';
import { Vertical } from './Vertical';
import ErrorDialog from '../utilities/ErrorDialog';

export interface IVerticalEditProps {
    open: boolean;
    onClose?: Function;
    onSave?: Function;
    selectedItem: Vertical | undefined;
}

export interface IVerticalEditState {
    open: boolean;
    hasErrors: boolean;
    errorMessage: string;
    verticales: any[];
    openErroDialog: boolean;
}

export default class VerticalEdit extends React.Component<IVerticalEditProps, IVerticalEditState> {
    _vertical: Vertical = new Vertical();
    _id: number = -1;
    
    public constructor(props: IVerticalEditProps) {
        super(props);

        this.state = {
            open: false,
            hasErrors: false,
            errorMessage: '',
            verticales: [],
            openErroDialog: false
        }
    }

    componentDidMount(): void {
        this.GetVerticales();
    }

    componentWillReceiveProps(nextProps: Readonly<IVerticalEditProps>, nextContext: any): void {
        if(nextProps.selectedItem != null) {
            this._vertical = nextProps.selectedItem;

            console.log('entrada', this._vertical);

            if(typeof this._vertical.parentId == 'object') {
                this._vertical.parentId = -1;
            }

            console.log('verticalillo', this._vertical);
        }

        this.setState({
            open: nextProps.open
        });
    }

    public render(): React.ReactElement<{}> {
        return (
            <React.Fragment>
                <Dialog open={this.state.open} fullWidth>
                    <DialogTitle>
                        Modificar vertical
                    </DialogTitle>
                    <DialogContent>
                        {
                            this.state.hasErrors && (
                                <Alert severity="error" style={{marginBottom: '10px'}}>
                                    {
                                        this.state.errorMessage
                                    }
                                </Alert>
                            )
                        }
                        <Box>
                            <FormControl fullWidth style={{marginBottom: '20px'}}>
                                <TextField required variant='standard' label='Vertical' defaultValue={this._vertical.name} onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                                    if(event.target.value == '') {
                                        this.setState(
                                            {
                                                hasErrors: true,
                                                errorMessage: 'Introduzca los valores correspondientes en los campos obligatorios.'
                                            }
                                        );
                                    }
                                    else {
                                        this.setState(
                                            {
                                                hasErrors: false,
                                                errorMessage: ''
                                            }
                                        );
                                        this._vertical.name = event.target.value;
                                    }
                                }}></TextField>
                            </FormControl>
                            <FormControl fullWidth variant="standard" style={{marginBottom: '20px'}}>
                                <InputLabel id="labelVerticales">Vertical del que depende</InputLabel>
                                <Select label="Vertical del que depende" labelId='labelVerticales' defaultValue={this._vertical.parentId == null || this._vertical.parentId == -1 ? '' : this._vertical.parentId!.toString()} onChange={(event: SelectChangeEvent) => {
                                    this.setState(
                                        {
                                            hasErrors: false,
                                            errorMessage: ''
                                        }
                                    );
                                    this._vertical.parentId = Number(event.target.value);
                                }}>
                                    {
                                        this.state.verticales.map((value: Vertical, index: number) => {
                                            return (
                                                <MenuItem value={value.id}>
                                                    {
                                                        value.name
                                                    }
                                                </MenuItem>
                                            )
                                        })
                                    }
                                </Select>
                            </FormControl>
                            <FormControl fullWidth style={{marginBottom: '20px'}}>
                                <TextField type='number' required variant='standard' defaultValue={this._vertical.defaultFallow} label='Barbecho por defecto (en días)' onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                                    if(event.target.value == '') {
                                        this.setState(
                                            {
                                                hasErrors: true,
                                                errorMessage: 'Introduzca los valores correspondientes en los campos obligatorios.'
                                            }
                                        );
                                    }
                                    else {
                                        this.setState(
                                            {
                                                hasErrors: false,
                                                errorMessage: ''
                                            }
                                        );
                                        this._vertical.defaultFallow = Number(event.target.value);
                                    }
                                }}></TextField>
                            </FormControl>
                        </Box>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={this.Update.bind(this)}>OK</Button>
                        <Button onClick={this.Close.bind(this)}>Cancelar</Button>
                    </DialogActions>
                </Dialog>
                <ErrorDialog open={this.state.openErroDialog} onClose={this.Close.bind(this)} />
            </React.Fragment>
        )
    }

    private Close() {
        this.setState(
            {
                open: false,
                openErroDialog: false,
                hasErrors: false,
                errorMessage: ''
            }
        );

        if(this.props.onClose != null) {
            this.props.onClose();
        }
    }

    private Update() {
        if(this._vertical.name == '' || this._vertical.name == null) {
            this.setState({
                hasErrors: true,
                errorMessage: 'Introduzca los valores correspondientes en los campos obligatorios o seleccione un archivo.'
            })
            return;
        }

        console.log('this._vertical', this._vertical);

        let url = `${Common.END_POINT}/masters/verticales/${this._vertical.id}/update`;
        $.ajax((
            {
                url: url,
                type: "POST",
                data: JSON.stringify(this._vertical),
                dataType: "json",
                headers: {
                    "Accept": "application/json",
                    "Content-Type": "application/json"
                },
                beforeSend: function (xhr) {
                    xhr.setRequestHeader('Authorization', `Bearer ${Common.GetToken()}`);
                }
            }
        )).done(() => {
            if(this.props.onSave != null) {
                this.props.onSave();
            }

            this._vertical = new Vertical();
        }).fail((jqXHR, textStatus, errorThrown) => {
            this.setState(
                {
                    open: false,
                    openErroDialog: false
                }
            );
    
            if(this.props.onSave != null) {
                this.props.onSave();
            }

            this._vertical = new Vertical();
        });
    }

    private GetVerticales() {
        let url = `${Common.END_POINT}/masters/Verticales`;
        
        $.ajax((
            {
                url: url,
                type: "GET",
                headers: {
                    "Accept": "application/json",
                    "Content-Type": "application/json"
                },
                beforeSend: function (xhr) {
                    xhr.setRequestHeader('Authorization', `Bearer ${Common.GetToken()}`);
                }
            }
        )).done((response: any[]) => {
            this.setState(
                {
                    verticales: response
                }
            );
        })
    }
}